import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { OPERATIONAL_PIVOT } from 'src/constants'
import {
  ACTION_GET_PATCH_DELETE,
  ACTION_HUB
} from 'src/scenes/ActionHub/constants'

export const getActions = async (config = {}) => {
  const { query = {} } = config

  try {
    const response = await httpClient.request({
      method: 'get',
      url: {
        pathname: ACTION_HUB,
        query
      }
    })

    return response
  } catch (err) {
    catchError(err)
  }
}

export const getTask = async (config = {}) => {
  const { params = {} } = config

  try {
    const item = await httpClient.request({
      method: 'get',
      url: {
        pathname: ACTION_GET_PATCH_DELETE,
        params
      }
    })

    return item
  } catch (err) {
    catchError(err)

    return {}
  }
}

export const fetchOperationalPivot = async (config = {}) => {
  const { query = {} } = config

  try {
    const data = await httpClient.request({
      method: 'get',
      url: {
        pathname: OPERATIONAL_PIVOT,
        query
      }
    })

    return data
  } catch (err) {
    catchError(err)
  }
}
